export const POPOUT_V2_QUERY = 'popoutv2';
export const POPOUT_V2_VALUE = '1';
